import { $, $$ } from 'utils/dom';

const cardSliders = $$('.cards-slider');

if (cardSliders.length) {
  Promise.all([import('flickity'), import('flickity-imagesloaded')]).then(_ => {
    cardSliders.forEach(target => {
      const Flickity = _[0].default;
      const carousel = $('.cards-slider__items', target);
      const numberOfSlides = $$('.cards-slider__item', target).length;

      if (numberOfSlides > 4) {
        // eslint-disable-next-line no-new
        new Flickity(carousel, {
          cellAlign: 'left',
          contain: true,
          wrapAround: true,
          pageDots: false,
          imagesLoaded: true,
          lazyResize: 500, // prevents resize bug if slides has width: max-content
          arrowShape:
            'M32.6788 42.6722h69.7046v17.0224h-69.7869l30.649 30.649-12.0732 12.0732-51.1556-51.1556 51.3111-51.3111 12.0366 12.0366-30.6856 30.6856z',
        });
      }
    });
  });
}
